import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import 'vuetify/dist/vuetify.min.css'
import router from './router/index'
import VueRouter from "vue-router"
import dutyFn from "./router/router.js"
import 'swiper/css/swiper.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 兼容ie11
import 'babel-polyfill'
import { Browser } from "./tools/index";
import { windows } from './tools/index'
Browser.isWhich()
Vue.config.producionTip = false
Vue.use(VueRouter)
Vue.use(ElementUI);

// 前置导航守卫
router.beforeEach((to, from, next) => {
  switch (to.name) {
    case "home": dutyFn(to, from); break;
    case "watch": dutyFn(to, from); break;
    case "more": dutyFn(to, from); break;
    case "downloads": dutyFn(to, from); break;
    case "videos": dutyFn(to, from); break;
    case "secondWatch": dutyFn(to, from); break;
  }
  next()
})


new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
window.onload = function () {
  windows.onScroll(e => {
    // console.log(e);
    if (e > 80) {
      console.log("home", e);
    }
  });
}